import React from 'react';
import PropTypes from 'prop-types'
import { Field } from 'redux-form';
import renderTextField from '../../components/MaterialUi/renderTextField';
import RFSelectField from '../../components/ReduxFormComps/RFSelectField';
import RFCheckboxField from '../../components/ReduxFormComps/RFCheckboxField';

const RFSelectWithOverrideComponent=(props)=>{
    const { code,desc } = props.dataDict
    const { overrideCheckBoxFieldName,overrideCheckBoxLabel,
        label,fieldName,customStyle,datas } = props

    return (
        <div>
            {props[overrideCheckBoxFieldName]?(
                <Field
                    name={fieldName}
                    component={renderTextField}
                    label={label}
                    style={customStyle}
                />
            ):(
                <Field
                    label={label}
                    name={fieldName}
                    datas={datas}
                    component={RFSelectField}
                    codeField={code}
                    descField={desc}
                    customStyle={customStyle}
                />
            )}
            
            <Field 
                name={overrideCheckBoxFieldName} 
                component={RFCheckboxField} 
                label={overrideCheckBoxLabel}
            />
        </div>    
    )
}

RFSelectWithOverrideComponent.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    datas: PropTypes.array.isRequired,
    dataDict: PropTypes.object.isRequired,
    overrideCheckBoxFieldName: PropTypes.string.isRequired,
    overrideCheckBoxLabel: PropTypes.string.isRequired,
    customStyle: PropTypes.object
}

export default RFSelectWithOverrideComponent


// WEBPACK FOOTER //
// ./src/components/ReduxFormComps/RFSelectWithOverrideComponent.js